import {
  influhire,
  menamedica,
  menacheckout,
} from "../../assets/images/index.js";
import { productshero } from "../../assets/images";

export const ProjectsHeroData = {
  title: "Apps made to order",
  paragraph: "Don’t speak tech? Then let us develop your app idea",
  primaryButtonText: "Get a free demo",
  primaryButtonLink: "#",
  secondaryButtonText: "See pricing and plans",
  secondaryButtonLink: "#",
  list: [
    "We can build anything, regardless of complexity",
    "Guaranteed pricing and clear timelines",
    "Aftercare keeps your software up to date and bug free",
  ],
  mainImage: productshero,
};

export const productsFeatureData = [
  {
    title: "MenaMedica.com",
    paragraph:
      "Find Top-Quality Equipment Hassle-Free We use only the best quality materials on the market in order to provide the best products to our patients, So dont worry about anything and book yourself.",
    image: menamedica,
    imagePosition: "left",
    primaryButtonText: "Visit Website",
    primaryButtonLink: "https://menamedica.com/",
  },
  {
    title: "InfluHire.com",
    paragraph:
      "Maximize Your Impact, Engage Globally. Enhance your brand and broaden your reach with our premier influencer marketing platform. Connect with leading influencers and leverage tailored strategies to engage audiences worldwide. Transform your digital presence with impactful content crafted to resonate and inspire.",
    image: influhire,
    imagePosition: "right",
    primaryButtonText: "Visit Website",
    primaryButtonLink: "https://influhire.com/",
  },
  {
    title: "MenaCheckout.com",
    paragraph:
      "Complete payment Services, Powerful Solutions for Seamless Growth. Experience a comprehensive platform that combines end-to-end payments, data analytics, and streamlined financial management. Discover how our financial technology solution can accelerate your path to success.",
    image: menacheckout,
    imagePosition: "left",
    primaryButtonText: "Visit Website",
    primaryButtonLink: "https://menacheckout.com/",
  },
];
